import { render } from "./RubInr.vue?vue&type=template&id=3ed16e21"
import script from "./RubInr.vue?vue&type=script&lang=js"
export * from "./RubInr.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__